import {isMobile} from "./isMobile";
import "jquery-smooth-scroll";

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  if (window.location.pathname === '/') {
    var offset = (isMobile()) ? -60 : -100;

    $("#media_image-6 a").attr({
      "href": "#individuals",
      "data-toggle": "tab"
    });

    $("#media_image-7 a").attr({
      "href": "#corporations",
      "data-toggle": "tab"
    });

    $("#media_image-6 a, #media_image-7 a").addClass("link-tab");


    $('a.link-tab').on('shown.bs.tab', function (e) {
      $('.nav-tabs .active').removeClass('active');
      $('a[href="' + $(this).attr('href') + '"]').parent().addClass('active');

      var that = this;

      $('html, body').animate({
        scrollTop: $($(that).attr('href')).offset().top + offset
      }, 500);
    });
  }
});

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  // if (typeof $.smoothScroll !== 'function') {
  //   return false;
  // }

  var reSmooth = /^#sm-/;
  var id;

  $(window).on("load", function () {
    if (reSmooth.test(location.hash)) {
      id = '#' + location.hash.replace(reSmooth, '');
      var offset = (isMobile()) ? -60 : -100;
      $('a[href="' + id + '"]').trigger('click');

      var $id = $(id);
      var offsetSm = $id.data('offset-sm');
      var offsetMd = $id.data('offset-md');

      if (isMobile() && offsetSm) {
        offset = offsetSm;
      } else if (offsetMd) {
        offset = offsetMd;
      }

      $.smoothScroll({
        scrollTarget: id,
        offset: offset,
        easing: 'easeInOutCubic'
      });
    }
  });
});


/*
 *
 * ----------------------------------------------- */
// jQuery Smooth Scroll - v2.2.0 - 2017-05-05
// https://github.com/kswedberg/jquery-smooth-scroll
// jQuery(function ($) {
//   $('[data-sm]').smoothScroll({
//     offset: -10,
//     beforeScroll: function(e) {
//       var scrollTarget = e.scrollTarget;
//
//       if (scrollTarget === '#form-title') {
//         if (isMobile()) {
//           e.offset = -20;
//         } else {
//           e.offset = -30;
//         }
//       } else if (scrollTarget === '#section-media') {
//         e.offset = -10;
//       }
//     }
//   });
// });
